module.exports = __webpack_public_path__ + "static/media/info-icon-blue.fe73150a.svg";